<template>
  <div id="listbox">
    <img src="@/assets/img/Special/post2.png" />
    <ul class="lists">
      <li v-for="(item, index) in lists" :key="item.id">
        <div class="card-item">
          <div class="header">
            <!-- <img src="@/assets/img/Special/code.png" /> -->
            <div class="omit">{{ item.gcName }}</div>
            <div>NO.{{ index + 1 }}</div>
          </div>
          <!-- <div class="info">
          <div>订单号</div>
          <div class="omit">{{ item.ordNo }}</div>
        </div> -->
          <!-- gcShape 0：卡号卡密 1：卡密 2：卡号短链 3：卡号短链验证码 -->
          <template v-if="[0].includes(item.gcShape)">
            <div class="info">
              <div>卡&nbsp;&nbsp;&nbsp;号</div>
              <div class="omit">{{ item.cardNo }}</div>
              <div
                class="btn"
                v-clipboard:copy="item.cardNo"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="info">
              <div>密&nbsp;&nbsp;&nbsp;码</div>
              <div class="omit">{{ item.cardPwd }}</div>
              <div
                class="btn"
                v-clipboard:copy="item.cardPwd"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
          </template>
          <div class="info" v-if="[1].includes(item.gcShape)">
            <div>卡&nbsp;&nbsp;&nbsp;密</div>
            <div class="omit">{{ item.cardPwd }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="info" v-if="[2].includes(item.gcShape)">
            <div>短&nbsp;&nbsp;&nbsp;链</div>
            <div class="omit">{{ item.shortUrl }}</div>
            <div
              class="btn"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <template v-if="[3].includes(item.gcShape)">
            <div class="info" v-show="item.cardNo">
              <div>卡&nbsp;&nbsp;&nbsp;号</div>
              <div class="omit">{{ item.cardNo }}</div>
              <div
                class="btn"
                v-clipboard:copy="item.cardNo"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="info">
              <div>短&nbsp;&nbsp;&nbsp;链</div>
              <div class="omit">{{ item.shortUrl }}</div>
              <div
                class="btn"
                v-clipboard:copy="item.shortUrl"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="info">
              <div>密&nbsp;&nbsp;&nbsp;码</div>
              <div class="omit">{{ item.verifyCode }}</div>
              <div
                class="btn"
                v-clipboard:copy="item.verifyCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
          </template>
        </div>

        <div class="lform explain">
          <div class="tips">商品说明</div>
          <div v-html="item.describe"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { listRedeemCode } from '@/api/Special.js'
export default {
  data() {
    return {
      lists: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { code, data, message } = await listRedeemCode(this.$route.query)
      if (code === 0) {
        data.forEach(item => {
          if (item.gcText) {
            const _describe = item.gcText.split('本地生活商详')
            item.describe =
              _describe.length > 0 ? _describe[_describe.length - 1] : ''
          }
        })
        this.lists = data
      } else {
        this.$toast.fail({
          message: message
        })
      }
    },
    copySuccess() {
      this.$toast({
        message: '复制成功'
      })
    },
    copyError() {
      this.$toast({
        message: '复制失败'
      })
    }
  }
}
</script>

<style lang="less" scoped>
// @import '~@/assets/style/Special.less';

// 兑换商品增加了商品说明,样式无法和共用的样式一致，所以单独写一个样式

// list
#listbox {
  background: #9fc3ff;
  min-height: 100vh;
  overflow: hidden;
  & > img {
    width: 100%;
    padding: 3.9vw 3.9vw 5.07vw;
    box-sizing: border-box;
  }
  & > h5 {
    font-size: 3.12vw;
    color: #666666;
    text-align: center;
    padding-bottom: 7.67vw;
  }
  .lists {
    padding: 0 3.9vw 7.15vw;
    .card-item {
      background: #598ae8;
      border-radius: 15px;
      overflow: hidden;
      margin-bottom: 3.9vw;
      padding-bottom: 7.4vw;
      .info {
        display: flex;
        align-items: center;
        font-size: 3.64vw;
        color: #ffffff;
        padding: 5.85vw 6.5vw 0vw;
        .btn {
          width: 12.48vw;
          line-height: 5.2vw;
          background: #ffffff;
          border-radius: 2.6vw;
          color: #1143c9;
          text-align: center;
        }
      }
      .omit {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        padding: 0 2.47vw;
      }
      .header {
        display: flex;
        margin: 0 3.9vw 0.9vw;
        padding: 2.21vw 0;
        align-items: center;
        border-bottom: 1px dashed #ffffff;
        font-size: 4.16vw;
        color: #ffffff;
        position: relative;
        &::before {
          position: absolute;
          width: 4.38vw;
          height: 4.38vw;
          content: '';
          top: 10vw;
          left: -6vw;
          background: #9fc3ff;
          border-radius: 2.5vw;
        }
        &::after {
          position: absolute;
          width: 4.38vw;
          height: 4.38vw;
          content: '';
          top: 10vw;
          right: -6vw;
          background: #9fc3ff;
          border-radius: 2.5vw;
        }
        & > img {
          width: 7.8vw;
          height: 7.8vw;
        }
      }
    }
  }

  .tips {
    background: url('~@/assets/img/Special/tips.png') 0 center no-repeat;
    background-size: 3.9vw 4.42vw;
    font-size: 4.16vw;
    border-bottom: solid 1px #f0f0f0;
    line-height: 11.83vw;
    margin-bottom: 3.9vw;
    padding-left: 6.37vw;
    color: #323234;
  }
  .explain {
    padding-top: 0;
    font-size: 3.12vw;
    color: #666666;
    line-height: 2;
  }

  .lform {
    margin-bottom: 3.9vw;
    background: #fff;
    padding: 3vw 6.5vw 5.85vw 6.5vw;
    box-sizing: border-box;
    border-radius: 15px;
    .lform-input {
      border: solid 1px #bfd7ff;
      line-height: 11.44vw;
      margin-bottom: 3.77vw;
      width: 100%;
      box-sizing: border-box;
      border-radius: 5px;
      padding: 0 1.3vw 0 13vw;
      font-size: 3.64vw;
    }
    .key {
      background: url('~@/assets/img/Special/key.png') 4.94vw center no-repeat;
      background-size: 3.9vw 4.42vw;
    }
    .phone {
      background: url('~@/assets/img/Special/phone.png') 4.94vw center no-repeat;
      background-size: 3.9vw 4.42vw;
    }
    .yzm {
      padding: 0;
      display: flex;
      /deep/ .van-field__control {
        background: url('~@/assets/img/Special/code.png') 4.94vw center
          no-repeat;
        background-size: 3.9vw 4.42vw;
        border: 0;
        padding: 0 1.3vw 0 13vw;
        /* max-width: 30.3vw; */
        width: 45vw;
      }
      /deep/ .van-field__error-message {
        padding: 0 1.3vw 0 13vw;
      }
    }
  }
}
</style>
